var _path, _path2, _path3, _path4, _path5, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8ChainIntermidiate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0078d4",
    d: "M28,8.69c-.16-.06-.33-.12-.5-.17s-.34-.1-.5-.14a12.03211,12.03211,0,0,0-6,0c-.16.04-.33.09-.5.14s-.34.11-.5.17A12.004,12.004,0,0,0,12,20v8a12.00415,12.00415,0,0,0,8,11.31c.16.06.33.12.5.17s.34.1.5.14a12.03211,12.03211,0,0,0,6,0c.16-.04.33-.09.5-.14s.34-.11.5-.17A12.00415,12.00415,0,0,0,36,28V20A12.004,12.004,0,0,0,28,8.69ZM30,28a5.94712,5.94712,0,0,1-2,4.46,4.71856,4.71856,0,0,1-.5.41,3.8393,3.8393,0,0,1-.5.32,5.96056,5.96056,0,0,1-6,0,3.8393,3.8393,0,0,1-.5-.32,4.71856,4.71856,0,0,1-.5-.41A5.94712,5.94712,0,0,1,18,28V20a5.94725,5.94725,0,0,1,2-4.46,4.72528,4.72528,0,0,1,.5-.41,3.833,3.833,0,0,1,.5-.32,5.96056,5.96056,0,0,1,6,0,3.833,3.833,0,0,1,.5.32,4.72528,4.72528,0,0,1,.5.41A5.94725,5.94725,0,0,1,30,20Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1b9de2",
    d: "M21,2h6a0,0,0,0,1,0,0V16a3,3,0,0,1-3,3h0a3,3,0,0,1-3-3V2A0,0,0,0,1,21,2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1b9de2",
    d: "M24,29h0a3,3,0,0,1,3,3V46a0,0,0,0,1,0,0H21a0,0,0,0,1,0,0V32A3,3,0,0,1,24,29Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5,8.52c-.17.05005-.34.11-.5.17v6.85a4.72528,4.72528,0,0,1,.5-.41,3.833,3.833,0,0,1,.5-.32V8.38C20.84,8.42,20.67,8.47,20.5,8.52Zm7,0c-.17-.05-.34-.1-.5-.14v6.43a3.833,3.833,0,0,1,.5.32,4.72528,4.72528,0,0,1,.5.41V8.69C27.84,8.63,27.67,8.57,27.5,8.52Z",
    opacity: 0.05
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5,8.52v6.61a3.833,3.833,0,0,1,.5-.32V8.38C20.84,8.42,20.67,8.47,20.5,8.52ZM27,8.38v6.43a3.833,3.833,0,0,1,.5.32V8.52C27.33,8.47,27.16,8.42,27,8.38Z",
    opacity: 0.07
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27.5,32.87a3.8393,3.8393,0,0,1-.5.32v6.43c.16-.04.33-.09.5-.14s.34-.11.5-.17V32.46A4.71856,4.71856,0,0,1,27.5,32.87ZM20,32.46v6.85c.16.06.33.12.5.17s.34.1.5.14V33.19a3.8393,3.8393,0,0,1-.5-.32A4.71856,4.71856,0,0,1,20,32.46Z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,33.19v6.43c.16-.04.33-.09.5-.14V32.87A3.8393,3.8393,0,0,1,27,33.19Zm-6.5,6.29c.17.05.34.1.5.14V33.19a3.8393,3.8393,0,0,1-.5-.32Z",
    opacity: 0.07
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8ChainIntermidiate);
export default __webpack_public_path__ + "static/media/icons8-chain-intermidiate.6c974ae0aa49346af18311cbbb696e4c.svg";
export { ForwardRef as ReactComponent };